import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import store from '../store/index'
import axios from 'axios'
import qs from 'qs';
import { config } from '../puConfig'
//获取全部路由链接
import Public from '@/router/routers/public.js'
import Course from '@/router/routers/course.js'
import Ask from '@/router/routers/ask.js'
import Testing from '@/router/routers/testing.js'
import Enroll from '@/router/routers/enroll.js'
import Product from '@/router/routers/product.js'
import User from '@/router/routers/user.js'
import Migrant from '@/router/routers/migrant'
import Book from '@/router/routers/book'

//路由合并
var routes = Public.concat(User, Course, Testing, Product, Enroll, Ask, Migrant, Book);
Vue.use(Router)


const router = new Router({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
if (config.DE_BUG) {
	//全局路由加载之前(测试)
	router.beforeEach((to, from, next) => {
		//防止当在加载loading的时候,用户使用物理后退按钮，导致了页面虽然跳转但是loading依然存在问题
		if (to.name === '404') {
			next();
			return;
		}
		//用来调到主页面,这个是进入方便的，正式版不存在
		if (to.path === "/") {
			router.replace({ path: '/home' });
			return;
		}
		//如果页面不存在则跳到404页面
		if (to.matched.length === 0) {
			router.replace({ path: "/404" });
			return;
		}
		//console.log('验证登陆')
		next();
		// return;
		//获取小写
		let toQuery = {};
		for (let x in to.query) {
			toQuery[x.toLowerCase()] = to.query[x];
		}
		let fromQuery = {};
		for (let x in to.query) {
			fromQuery[x.toLowerCase()] = from.query[x];
		}
		//当获取wxid
		let wxid = store.state.wxId;
		// 不存在Wxid时,跳转至404
		if (!wxid) {
			router.replace({ path: "/404" });
			next(false);
			return false;
		}
		next();
		return;
	})
} else {
	//全局路由加载之前(正式)
	router.beforeEach((to, from, next) => {

		//设置title
		if (to.name) {
			document.title = to.name
		}

		//如果当前页面为404则直接进入
		if (to.name === '404') {
			next();
			return;
		}
		//如果页面不存在则跳到404页面
		if (to.matched.length === 0) {
			router.replace({ path: "/404" });
			return;
		}
		//获取小写
		let toQuery = {};
		for (let x in to.query) {
			toQuery[x.toLowerCase()] = to.query[x];
		}
		let fromQuery = {};
		for (let x in to.query) {
			fromQuery[x.toLowerCase()] = from.query[x];
		}
		if (/(iPhone|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) {
			let ua = window.navigator.userAgent.toLowerCase()
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				if (!store.state.wxId && to.path != '/author') {
					// 第一次进入项目
					Cookies.set('beforeLoginUrl', to.fullPath) // 保存用户进入的url
					next('/author')
					return false
				}
				if (to.path == '/author' && store.state.wxId) {
					// 用户使用后退返回到授权页，则默认回到首页
					next('/home')
					return false
				}
			}
			var u = navigator.userAgent;
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			// XXX: 修复iOS版微信HTML5 History兼容性问题
			if (isiOS && to.path !== location.pathname) {
				// 此处不可使用location.replace
				location.assign(to.fullPath)
			} else {
				next()
			}
		} else {
			router.replace({ path: "/404" });
			return;
		}
		next();
		return;
	})
}

export { router }


// WEBPACK FOOTER //
// ./src/router/index.js